import { render, staticRenderFns } from "./UserAnnouncementList.vue?vue&type=template&id=7236a948&scoped=true"
import script from "./UserAnnouncementList.vue?vue&type=script&lang=js"
export * from "./UserAnnouncementList.vue?vue&type=script&lang=js"
import style0 from "./UserAnnouncementList.vue?vue&type=style&index=0&id=7236a948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7236a948",
  null
  
)

export default component.exports